/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from '@emotion/react';
import ouiStyle from '@goldwasserexchange/oui-style';
import geBuildingLarge from './geBuildingLarge.jpg';

const buildingImageStyle: ouiStyle.InStyle = {
  widthLines: 'screenWidth',
  paddingVertical: 'none',
  minLines: 5,
};

const buildingImageCss = {
  ...ouiStyle.makeCss(buildingImageStyle),
  height: `${(701 / 2840) * 100}vw`,
};

export const BuildingImage = () => (
  <img
    src={geBuildingLarge}
    css={buildingImageCss}
    alt="batiment de Goldwasser Exchange à Saint-Gilles"
  />
);
